module.exports = __webpack_public_path__ + "img/product_blue.44d95d27.jpg";